<template>
    <v-card class='mr-2 mb-2' width='250' height='350'>
                 <v-img
                v-bind:src="productImage"
                height="210px"
                ></v-img>
                <v-card-title>{{productName}}</v-card-title>
                <v-card-text>
                    <v-card-actions>
                        <v-row justify='space-between'  align='center'>
                            <v-switch class='pt-0 pb-0' v-model='inStock' @change="onProductSwitch" label='In Stock'></v-switch>
                            <v-btn color='primary' text @click.stop="onProductEdit">Edit</v-btn>
                        </v-row>
                       
                    </v-card-actions>
                    
                </v-card-text>
    </v-card>
</template>

<script>
export default {
    name:'Product',
    props:['productId','productName','inStock','productPrice','productUnits','productImage'],
    methods:{
        onProductEdit(){
            this.$emit('onProductEdit',{
                productId: this.productId,
                productName: this.productName,
                productPrice: this.productPrice,
                productUnits:this.productUnits,
                productInStock : this.inStock,
                productImage : this.productImage,
                editDialog:true
            })
        },
        onProductSwitch()
        {
            this.$emit('onProductSwitch', {
                productId: this.productId,
                inStock : this.inStock
            })
        }
    }
}
</script>